import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { useTheme } from '@chakra-ui/react';
import { useViewportType } from '@/hooks';

import { Headline } from '@ldp-web/component-library/ui/molecules/headline';
import { Link } from '@ldp-web/component-library/ui/atoms/link';
import { Image } from '@ldp-web/component-library/ui/atoms/image';

import styles from './pharmaprix-pharmacy-disclaimer.module.scss';
import { chevronRightIcon } from 'Data/constants';

const PharmaprixPharmacyDisclaimer: React.FC = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();
  const viewportType = useViewportType();
  const isDesktopView = viewportType === 'desktop';
  const {
    linkDefault,
    content: { spacingExtraLarge, spacingLarge },
  } = useTheme();

  const disclaimerStyles = {
    marginTop: isDesktopView ? spacingExtraLarge : spacingLarge,
    ...(isDesktopView ? {} : { marginBottom: spacingLarge }),
  };
  const handleLinkClick = useCallback(() => {
    router.push('/store-locator/pharmacist-owners/');
  }, [router]);

  return (
    <div className={styles.pharmaprixPharmacyDisclaimer} style={disclaimerStyles}>
      <Headline
        title={formatMessage({ id: 'pharmaprixPharmacyOwnerText' })}
        data-testid="phx-pharmacy-disclaimer-headline"
        headlineSize={1}
      />
      <div>
        <Link sx={{ ...linkDefault }} className={styles.learnMore} onClick={handleLinkClick}>
          {formatMessage({ id: 'pharmaprixPharmacyOwnerLearnMore' })}
          <Image src={chevronRightIcon} alt={`Link to ${formatMessage({ id: 'pharmaprixPharmacyOwnerLearnMore' })}`} />
        </Link>
      </div>
    </div>
  );
};

export default PharmaprixPharmacyDisclaimer;
